import styled from 'styled-components';

export const GridContainer = styled.div`
  padding: 0;
  border-radius: 8px 8px 0 0;
  flex: 1 1 auto;
  height: 100%;
  position: relative;
`;

export const TabActionsContainer = styled.div`
  .MuiSpeedDial-fab {
    background-color: #5890aa;
    color: #fff;
  }
  .MuiSpeedDialAction-fab {
    background-color: #5890aa;
    color: #fff;
  }
`;
